// ─────────────────────────────────────────────────────────────────
// Glass-i — Manual Charge Master API client (Stage 6Q).
//
// Thin axios wrappers around /api/erp/masters/manual-charges/*. The
// CRUD page uses list/create/update/remove; the Proforma manual-charges
// picker uses `lookups` (active entries + default Rs).
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/masters/manual-charges';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : resp && resp.data;
}

export const manualChargeApi = {
  list:    (params = {}) => client.get(BASE, { params }).then(unwrap),
  lookups: (params = {}) => client.get(`${BASE}/lookups`, { params }).then(unwrap),
  get:     (id)          => client.get(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  create:  (payload)     => client.post(BASE, payload).then(unwrap),
  update:  (id, payload) => client.put(`${BASE}/${encodeURIComponent(id)}`, payload).then(unwrap),
  remove:  (id)          => client.delete(`${BASE}/${encodeURIComponent(id)}`).then(unwrap)
};

// Soft-fail lookup for the Proforma picker — returns [] on any error so a
// transient master outage never breaks the proforma editor.
export async function loadManualChargeLookupsSafe() {
  try {
    const out = await manualChargeApi.lookups();
    return Array.isArray(out && out.rows) ? out.rows : (Array.isArray(out) ? out : []);
  } catch (_e) {
    return [];
  }
}

export default manualChargeApi;
